import { Link } from "react-router";
import { useMarketplace } from "../hooks/useMarketplace";

export function OrdersPage() {
  const { bids, holdRequests, listings, orders } = useMarketplace();
  const listingById = new Map(listings.map(listing => [listing.id, listing]));

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm ">
      <h1 className="text-4xl font-black">Orders</h1>
      <div className="mt-6 space-y-3">
        {orders.map(order => (
          <Link className="block rounded-2xl bg-slate-50 p-5 hover:bg-slate-100" key={order.id} to={`/orders/${order.id}`}>
            <strong>{order.id}</strong>
            <p className="text-slate-600">{order.status.replace("_", " ")} · {order.nextAction}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 rounded-2xl border border-slate-200 bg-slate-50 p-5">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs font-black uppercase tracking-[.24em] text-slate-500">Buyer activity</p>
            <h2 className="mt-2 text-2xl font-black">Offers & holds</h2>
          </div>
          <p className="text-sm font-bold text-slate-500">{bids.length} bids · {holdRequests.length} holds</p>
        </div>

        <div className="mt-5 grid gap-3 lg:grid-cols-2">
          {bids.map(bid => {
            const listing = listingById.get(bid.listingId);
            return (
              <div className="rounded-2xl bg-slate-50 p-4" key={bid.id}>
                <strong>{bid.id}</strong>
                <p className="mt-1 text-sm text-slate-600">Bid · {bid.status} · {listing?.name ?? bid.listingId}</p>
                <p className="mt-2 text-sm font-bold text-slate-950">{bid.quantity} unit @ ${bid.unitPrice.toLocaleString()} · expires {bid.expiresAt}</p>
              </div>
            );
          })}

          {holdRequests.map(hold => {
            const listing = listingById.get(hold.listingId);
            return (
              <div className="rounded-2xl bg-slate-50 p-4" key={hold.id}>
                <strong>{hold.id}</strong>
                <p className="mt-1 text-sm text-slate-600">Hold · {hold.status} · {listing?.name ?? hold.listingId}</p>
                <p className="mt-2 text-sm font-bold text-slate-950">{hold.quantity} unit · {hold.holdHours} hour request</p>
              </div>
            );
          })}

          {bids.length === 0 && holdRequests.length === 0 ? (
            <p className="rounded-2xl bg-slate-50 p-4 text-sm font-semibold text-slate-500">No active bids or hold requests yet.</p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
